import styled from 'styled-components';

export const S = {
  Wrapper: styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
  `,
};
